import * as ActionTypes from '../../constants/contents/KeywordActionTypes';

export const receiveItems = (items, totalCount) => ({
    type: ActionTypes.RECEIVE_ITEMS,
    items,
    totalCount
});

export const clearItems = () => ({
    type: ActionTypes.CLEAR_ITEMS
});

export const selectItem = (id) => ({
    type: ActionTypes.SELECT_ITEM,
    id
});

export const deselectItem = (id) => ({
    type: ActionTypes.DESELECT_ITEM,
    id
});

export const selectAllItems = () => ({
    type: ActionTypes.SELECT_ALL_ITEMS
});

export const deselectAllItems = () => ({
    type: ActionTypes.DESELECT_ALL_ITEMS
});

export const updateItem = (item) => ({
    type: ActionTypes.UPDATE_ITEM,
    item
});

export const updateSelectedItems = (values) => ({
    type: ActionTypes.UPDATE_SELECTED_ITEMS,
    values
});

export const searchKeyword = (searchKeyword, searchType) => ({
    type : ActionTypes.SEARCH_KEYWORD,
    searchKeyword,
    searchType
});

export const toggleMoreButton = (itemId) => ({
    type: ActionTypes.TOGGLE_MORE_BUTTON,
    itemId
});

export const toggleChangeStatusButton = (itemId) => ({
    type: ActionTypes.TOGGLE_CHANGE_STATUS_BUTTON,
    itemId
});

export const deleteItem = (item) => ({
    type: ActionTypes.DELETE_ITEM,
    item
});

export const deleteSelectedItems = (values) => ({
    type: ActionTypes.DELETE_SELECTED_ITEMS,
    values
});
